import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descarga el Protocolo',
    desc: 'Recibe acceso inmediato a tu guía digital en cualquier dispositivo.'
  }, {
    num: '2',
    title: 'Aplica los Micro-Rituales',
    desc: 'Introduce cambios de 2 a 5 minutos en tu mañana y noche.'
  }, {
    num: '3',
    title: 'Observa el Cambio',
    desc: 'Mira cómo la inflamación cede y tu ropa empieza a quedarte mejor en solo una semana.'
  }];
  return <section className="py-24 bg-sage-light/30" data-id="element-65">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <FadeIn data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-68">
            Cómo Funciona
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-69">
          {/* Connecting line desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-sage border-t border-dashed border-sage z-0" data-id="element-70" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-71">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="text-center" data-id="element-72">
                <div className="w-24 h-24 mx-auto bg-white rounded-full flex items-center justify-center text-4xl font-serif font-bold text-sage shadow-sm border-4 border-sage-light mb-6" data-id="element-73">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-74">{step.title}</h3>
                <p className="text-brown/70 leading-relaxed max-w-xs mx-auto" data-id="element-75">
                  {step.desc}
                </p>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}